module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/footer/footer.component.css
// module id = ./src/app/component/blocks/footer/footer.component.css
// module chunks = main